<template>
  <div class="">
    <div
      class="banner-info flex items-center gap-2 cursor-pointer"
      :style="borderStyles"
      @click="$emit('onToggleView')"
    >
      <p class="banner-info__text">
        <strong>{{ title || 'Tier Header' }}</strong>
      </p>
      <button :isDisabled="isDisabled">
        <img
          src="@/assets/dropdownarrow.svg"
          class="arrow"
          :class="{
            active: isAccordionOpen
          }"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionHeader',
  props: {
    title: {
      required: true,
      type: String
    },
    isAccordionOpen: {
      required: true,
      type: Boolean
    },
    isDisabled: {
      required: false,
      type: Boolean
    },
    borderStyles: {
      required: false,
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-header {
  .editorial {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.838rem;
  }
}
.banner-actions-holder {
  .banner-action {
    p {
      font-size: 0.838rem;
    }
  }
}
.banner-info {
  background-color: #dfdad2;
  padding: 1rem 1.66rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }

  .banner-info__text {
    font-size: 0.913rem;
  }
}
.arrow {
  width: 11px;
  cursor: pointer;
  transition: transform 0.8s ease;
}

.arrow.active {
  transform: rotateX(180deg);
}
</style>
